module.exports = __webpack_public_path__ + "img/GHB.bdb52ab0.png";